export default {"src":"/_next/static/media/stressMotivation.1954de07.svg","height":620,"width":1044,"blurWidth":0,"blurHeight":0};